import { combineReducers } from "redux";
import messagesReducer from "./messages/messages.reducer";
import widgetReducer from "./widget/widget.reducer";

const rootReducer = combineReducers({
  messagesData: messagesReducer,
  widgetData: widgetReducer,
});

export default rootReducer;
